(function(){
  'use strict';
  const db=()=>window.SM.DB, ui=()=>window.SM.UI, util=()=>window.SM.UTIL;

  const BIZ_CATS=[
    {id:'furniture',label:'Furniture & Home'},
    {id:'garden',label:'Garden & Outdoor'},
    {id:'toys',label:'Toys & Games'},
    {id:'electronics',label:'Electronics'},
    {id:'fashion',label:'Fashion & Clothing'},
    {id:'health',label:'Health & Beauty'},
    {id:'arts',label:'Arts & Crafts'},
    {id:'food',label:'Food & Grocery'},
    {id:'sports',label:'Sports & Fitness'},
    {id:'general',label:'General / Mixed'}
  ];

  async function load(){
    const content=document.getElementById('ims-company-content');
    if(!content)return;
    content.innerHTML=`<div class="ims__loading"><i class="ti ti-loader-2 ims__spin"></i></div>`;
    const {data:company,error}=await db().select('companies',{eq:{id:window.SM.AUTH.company?.id},maybeSingle:true,noCompanyFilter:true});
    if(error||!company){content.innerHTML=`<div class="ims__coming-soon"><i class="ti ti-building"></i><h3>Unable to load company</h3><p>${error?.message||'Please try again'}</p></div>`;return;}
    const cats=company.business_category||[];
    content.innerHTML=`
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:20px">
        <div>
          <h3 style="font-size:14px;font-weight:600;color:var(--ims-text);margin-bottom:12px">Business details</h3>
          <div class="ims__form-grid">
            <div class="ims__form-group ims__form-group--full">
              <label class="ims__label">Company logo</label>
              <div style="display:flex;align-items:center;gap:14px;margin-top:4px">
                ${company.logo_url
                  ? `<img src="${company.logo_url}" alt="Logo" style="height:60px;max-width:180px;object-fit:contain;border:1px solid var(--ims-border);border-radius:6px;padding:4px;background:var(--ims-surface)">`
                  : `<div style="width:120px;height:60px;border:2px dashed var(--ims-border);border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:12px;color:var(--ims-text-muted)">No logo</div>`}
                <div>
                  <input type="file" accept="image/png,image/jpeg,image/svg+xml,image/webp" id="ims-co-logo-file" style="display:none" onchange="window.IMS_COMPANY.previewLogo(this)">
                  <button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="document.getElementById('ims-co-logo-file').click()"><i class="ti ti-upload"></i> Upload logo</button>
                  ${company.logo_url?`<button class="ims__btn ims__btn--danger ims__btn--sm" style="margin-left:6px" onclick="window.IMS_COMPANY.removeLogo()"><i class="ti ti-trash"></i> Remove</button>`:''}
                  <div style="font-size:11px;color:var(--ims-text-muted);margin-top:4px">PNG, JPG or SVG. Max 2MB. Appears on invoices and printed documents.</div>
                  <div id="ims-co-logo-preview" style="margin-top:6px"></div>
                </div>
              </div>
            </div>
            <div class="ims__form-group ims__form-group--full"><label class="ims__label ims__label--req">Company name</label><input class="ims__input" type="text" id="ims-co-name" value="${util().sanitize(company.name||'')}"></div>
            <div class="ims__form-group ims__form-group--full"><label class="ims__label ims__label--req">Address line</label><input class="ims__input" type="text" id="ims-co-address" value="${util().sanitize(company.address||'')}" placeholder="e.g. Wern Industrial Estate"><span class="ims__input-hint">Street or estate name only — city, postcode and country are separate fields below</span></div>
            <div class="ims__form-group"><label class="ims__label">City / Town</label><input class="ims__input" type="text" id="ims-co-city" value="${util().sanitize(company.city||'')}" placeholder="e.g. Rogerstone, Newport"></div>
            <div class="ims__form-group"><label class="ims__label">Postcode</label><input class="ims__input" type="text" id="ims-co-postcode" value="${util().sanitize(company.postcode||'')}" placeholder="e.g. NP10 9FQ"></div>
            <div class="ims__form-group"><label class="ims__label">Country</label><input class="ims__input" type="text" id="ims-co-country" value="${util().sanitize(company.country||'United Kingdom')}" placeholder="e.g. United Kingdom"></div>
            <div class="ims__form-group"><label class="ims__label">Phone</label><input class="ims__input" type="tel" id="ims-co-phone" value="${util().sanitize(company.phone||'')}"></div>
            <div class="ims__form-group"><label class="ims__label">Email</label><input class="ims__input" type="email" id="ims-co-email" value="${util().sanitize(company.email||'')}"></div>
            <div class="ims__form-group"><label class="ims__label">Website</label><input class="ims__input" type="url" id="ims-co-web" value="${util().sanitize(company.website||'')}"></div>
            <div class="ims__form-group"><label class="ims__label">VAT number</label><input class="ims__input" type="text" id="ims-co-vat" value="${util().sanitize(company.vat_number||'')}"></div>
            <div class="ims__form-group"><label class="ims__label">VAT rate (%)</label><input class="ims__input" type="number" step="0.01" id="ims-co-vatrate" value="${company.vat_rate||20}"></div>
            <div class="ims__form-group"><label class="ims__label">Follow-up email</label><input class="ims__input" type="email" id="ims-co-followup" value="${util().sanitize(company.followup_email||'')}"><span class="ims__input-hint">Used for courier follow-ups and claims</span></div>
          </div>
          <hr class="ims__divider">
          <h3 style="font-size:14px;font-weight:600;color:var(--ims-text);margin-bottom:12px">Bank details</h3>
          <div class="ims__form-grid">
            <div class="ims__form-group"><label class="ims__label">Bank name</label><input class="ims__input" type="text" id="ims-co-bank" value="${util().sanitize(company.bank_name||'')}"></div>
            <div class="ims__form-group"><label class="ims__label">Account number</label><input class="ims__input" type="text" id="ims-co-acc" value="${util().sanitize(company.bank_account||'')}"></div>
            <div class="ims__form-group"><label class="ims__label">Sort code</label><input class="ims__input" type="text" id="ims-co-sort" value="${util().sanitize(company.bank_sort_code||'')}"></div>
            <hr class="ims__divider">
            <h3 style="font-size:14px;font-weight:600;color:var(--ims-text);margin-bottom:12px">Invoice settings</h3>
            <div class="ims__form-grid">
            <div class="ims__form-group"><label class="ims__label">Invoice prefix</label><input class="ims__input" type="text" id="ims-co-inv-prefix" value="${util().sanitize(company.invoice_prefix||'INV')}" placeholder="INV"></div>
            <div class="ims__form-group"><label class="ims__label">Credit note prefix</label><input class="ims__input" type="text" id="ims-co-cn-prefix" value="${util().sanitize(company.credit_note_prefix||'CN')}" placeholder="CN"></div>
            <div class="ims__form-group"><label class="ims__label">Debit note prefix</label><input class="ims__input" type="text" id="ims-co-dn-prefix" value="${util().sanitize(company.debit_note_prefix||'DN')}" placeholder="DN"></div>
            <div class="ims__form-group"><label class="ims__label">Default payment days</label><input class="ims__input" type="number" min="0" id="ims-co-pay-days" value="${company.default_payment_days||14}" placeholder="14"></div>
          </div>
          <hr class="ims__divider">
          <h3 style="font-size:14px;font-weight:600;color:var(--ims-text);margin-bottom:12px">Courier claims settings</h3>
          <div class="ims__form-grid">
            <div class="ims__form-group">
              <label class="ims__label">Default claim basis</label>
              <select class="ims__select" id="ims-co-claim-basis">
                <option value="retail" ${(company.claim_basis||'retail')==='retail'?'selected':''}>Retail price (unit price on order)</option>
                <option value="cost" ${company.claim_basis==='cost'?'selected':''}>Cost price (from product records)</option>
              </select>
              <span class="ims__input-hint">Sets the default starting price when raising a courier claim</span>
            </div>
            <div class="ims__form-group">
              <label class="ims__label">Default markup % on claims</label>
              <input class="ims__input" type="number" min="0" step="1" id="ims-co-claim-markup" value="${company.claim_markup_pct??20}" placeholder="20">
              <span class="ims__input-hint">Applied on top of the claim basis price — claim high, settle lower</span>
            </div>
          </div>
          </div>
        </div>
        <div>
          <h3 style="font-size:14px;font-weight:600;color:var(--ims-text);margin-bottom:12px">Business categories</h3>
          <p style="font-size:12px;color:var(--ims-text-muted);margin-bottom:10px">Select all categories that apply. This filters which platforms appear in Order Management.</p>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:16px">
            ${BIZ_CATS.map(c=>`
              <label style="display:flex;align-items:center;gap:8px;padding:8px 10px;background:var(--ims-surface2);border:1px solid var(--ims-border);border-radius:var(--ims-radius);cursor:pointer;font-size:13px">
                <input type="checkbox" id="ims-co-cat-${c.id}" ${cats.includes(c.id)?'checked':''}> ${c.label}
              </label>`).join('')}
          </div>
          <hr class="ims__divider">
          <h3 style="font-size:14px;font-weight:600;color:var(--ims-text);margin-bottom:12px">SMTP settings</h3>
          <div class="ims__form-grid">
            <div class="ims__form-group"><label class="ims__label">SMTP host</label><input class="ims__input" type="text" id="ims-co-smtp-host" value="${util().sanitize(company.smtp_host||'')}" placeholder="e.g. smtp.gmail.com"></div>
            <div class="ims__form-group"><label class="ims__label">SMTP port</label><input class="ims__input" type="number" id="ims-co-smtp-port" value="${company.smtp_port||587}"></div>
            <div class="ims__form-group"><label class="ims__label">SMTP username</label><input class="ims__input" type="text" id="ims-co-smtp-user" value="${util().sanitize(company.smtp_user||'')}"></div>
            <div class="ims__form-group"><label class="ims__label">SMTP password</label><input class="ims__input" type="password" id="ims-co-smtp-pass" placeholder="Enter to update"></div>
          </div>
        </div>
      </div>

      <div id="ims-danger-zone"></div>`;

    // Render danger zone after content is in DOM
    loadDangerZone();
  }

  let _pendingLogoFile=null;
  let _removeLogo=false;

  function previewLogo(input){
    const file=input.files?.[0];
    if(!file)return;
    if(file.size>2*1024*1024){ui().toast('Logo must be under 2MB','error');return;}
    _pendingLogoFile=file;
    _removeLogo=false;
    const reader=new FileReader();
    reader.onload=e=>{
      const preview=document.getElementById('ims-co-logo-preview');
      if(preview) preview.innerHTML=`
        <div style="display:flex;align-items:center;gap:8px">
          <img src="${e.target.result}" style="height:50px;max-width:150px;object-fit:contain;border:1px solid var(--ims-border);border-radius:4px;padding:3px">
          <span style="font-size:11px;color:var(--ims-success)"><i class="ti ti-check"></i> Ready to save</span>
        </div>`;
    };
    reader.readAsDataURL(file);
  }

  function removeLogo(){
    _pendingLogoFile=null;
    _removeLogo=true;
    const preview=document.getElementById('ims-co-logo-preview');
    if(preview) preview.innerHTML=`<span style="font-size:11px;color:var(--ims-danger)"><i class="ti ti-trash"></i> Logo will be removed on save</span>`;
    ui().toast('Logo will be removed when you save','info');
  }

  async function save(){
    const g=id=>document.getElementById(id)?.value?.trim()||'';
    const name=g('ims-co-name');
    if(!name){ui().toast('Company name is required','error');return;}
    const selectedCats=BIZ_CATS.map(c=>c.id).filter(id=>document.getElementById(`ims-co-cat-${id}`)?.checked);
    let logoUrl=window.SM.AUTH.company?.logo_url||null;

    if(_pendingLogoFile){
      try{
        const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
        const ext=_pendingLogoFile.name.split('.').pop();
        const path=`logos/${window.SM.AUTH.company?.id}/logo.${ext}`;
        const {error:uploadError}=await client.storage.from('company-assets').upload(path,_pendingLogoFile,{upsert:true,contentType:_pendingLogoFile.type});
        if(uploadError){
          const reader=new FileReader();
          logoUrl=await new Promise(res=>{reader.onload=e=>res(e.target.result);reader.readAsDataURL(_pendingLogoFile);});
        } else {
          const {data:urlData}=client.storage.from('company-assets').getPublicUrl(path);
          logoUrl=urlData.publicUrl;
        }
        _pendingLogoFile=null;
      }catch(e){
        ui().toast('Logo upload failed — saving without logo','warning');
      }
    } else if(_removeLogo){
      logoUrl=null;
      _removeLogo=false;
    }

    const data={
      name,address:g('ims-co-address')||null,city:g('ims-co-city')||null,postcode:g('ims-co-postcode')||null,country:g('ims-co-country')||null,phone:g('ims-co-phone')||null,
      email:g('ims-co-email')||null,website:g('ims-co-web')||null,
      vat_number:g('ims-co-vat')||null,vat_rate:parseFloat(g('ims-co-vatrate'))||20,
      followup_email:g('ims-co-followup')||null,bank_name:g('ims-co-bank')||null,
      bank_account:g('ims-co-acc')||null,bank_sort_code:g('ims-co-sort')||null,
      invoice_prefix:g('ims-co-inv-prefix')||'INV',
      credit_note_prefix:g('ims-co-cn-prefix')||'CN',
      debit_note_prefix:g('ims-co-dn-prefix')||'DN',
      default_payment_days:parseInt(g('ims-co-pay-days'))||14,
      claim_basis:g('ims-co-claim-basis')||'retail',
      claim_markup_pct:parseFloat(g('ims-co-claim-markup'))??20,
      business_category:selectedCats,smtp_host:g('ims-co-smtp-host')||null,
      smtp_port:parseInt(g('ims-co-smtp-port'))||587,smtp_user:g('ims-co-smtp-user')||null,
      logo_url:logoUrl,
      updated_at:new Date().toISOString()
    };
    const smtpPass=g('ims-co-smtp-pass');
    if(smtpPass) data.smtp_pass=smtpPass;
    const {error}=await db().update('companies',window.SM.AUTH.company?.id,data);
    if(error){ui().toast('Failed to save: '+error.message,'error');return;}
    Object.assign(window.SM.AUTH.company,data);
    ui().toast('Company settings saved','success');
  }

  // ─── DANGER ZONE ─────────────────────────────────────────────────
  function loadDangerZone(){
    if(!window.SM.AUTH.isAdmin())return;
    const container=document.getElementById('ims-danger-zone');
    if(!container)return;
    container.innerHTML=`
      <div class="ims__card" style="border:2px solid var(--ims-danger);margin-top:28px">
        <div class="ims__card-header">
          <div class="ims__card-title" style="color:var(--ims-danger)">
            <i class="ti ti-alert-triangle"></i> Danger Zone — Audit Reset
          </div>
        </div>
        <p style="font-size:13px;color:var(--ims-text-sec);margin-bottom:16px">
          Use these resets to wipe test/audit data after system testing.
          These actions are <strong>permanent and cannot be undone</strong>.<br>
          <span style="font-size:12px;color:var(--ims-text-muted)">
            Never deleted: products, stock levels, customers, couriers, drivers, vehicles,
            routes, warehouses, platforms, users, company settings.
          </span>
        </p>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px">
          <div style="padding:14px;background:var(--ims-surface2);border-radius:var(--ims-radius);border:1px solid var(--ims-border)">
            <div style="font-size:13px;font-weight:600;margin-bottom:6px">
              <i class="ti ti-shopping-cart" style="color:var(--ims-danger)"></i>
              Reset all orders &amp; logistics
            </div>
            <div style="font-size:12px;color:var(--ims-text-muted);margin-bottom:12px;line-height:1.6">
              Deletes all non-dropship orders, order items, logistics jobs, manifests,
              shipments, COD transactions, finance transactions, courier follow-ups,
              claims, and activity logs.<br>
              Resets all stock reserved quantities to zero.
            </div>
            <button class="ims__btn ims__btn--danger ims__btn--sm"
              onclick="window.IMS_COMPANY.confirmReset('orders')">
              <i class="ti ti-trash"></i> Reset orders &amp; logistics
            </button>
          </div>
          <div style="padding:14px;background:var(--ims-surface2);border-radius:var(--ims-radius);border:1px solid var(--ims-border)">
            <div style="font-size:13px;font-weight:600;margin-bottom:6px">
              <i class="ti ti-truck-delivery" style="color:var(--ims-danger)"></i>
              Reset dropship orders &amp; invoices
            </div>
            <div style="font-size:12px;color:var(--ims-text-muted);margin-bottom:12px;line-height:1.6">
              Deletes all dropship orders (fulfillment_type = dropship), their order items,
              logistics jobs, activity logs, dropship invoices, and invoice lines.
              Non-dropship orders are not touched.
            </div>
            <button class="ims__btn ims__btn--danger ims__btn--sm"
              onclick="window.IMS_COMPANY.confirmReset('dropship')">
              <i class="ti ti-trash"></i> Reset dropship data
            </button>
          </div>
        </div>
      </div>`;
  }

  async function confirmReset(type){
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    const labels={
      orders:  'all orders, logistics jobs, manifests, shipments, COD accounts, and finance transactions',
      dropship:'all dropship orders, invoices, and invoice lines'
    };

    // Count records that will be deleted so admin can see exactly what's going
    let countHtml='';
    if(type==='orders'){
      const [
        {count:ordCount},{count:itemCount},{count:jobCount},
        {count:mfCount},{count:shipCount},{count:txnCount},
        {count:codCount},{count:claimCount},{count:followupCount}
      ]=await Promise.all([
        client.from('orders').select('*',{count:'exact',head:true}).neq('fulfillment_type','dropship'),
        client.from('order_items').select('*',{count:'exact',head:true}),
        client.from('logistics_jobs').select('*',{count:'exact',head:true}),
        client.from('manifests').select('*',{count:'exact',head:true}),
        client.from('shipments').select('*',{count:'exact',head:true}),
        client.from('transactions').select('*',{count:'exact',head:true}),
        client.from('cod_transactions').select('*',{count:'exact',head:true}),
        client.from('claims').select('*',{count:'exact',head:true}),
        client.from('courier_followups').select('*',{count:'exact',head:true})
      ]);
      countHtml=`
        <table class="ims__table" style="margin:12px 0">
          <thead><tr>
            <th>Table</th>
            <th style="text-align:right">Records to delete</th>
          </tr></thead>
          <tbody>
            <tr><td>Orders (non-dropship)</td><td style="text-align:right;font-weight:600;color:var(--ims-danger)">${ordCount||0}</td></tr>
            <tr><td>Order items</td><td style="text-align:right">${itemCount||0}</td></tr>
            <tr><td>Logistics jobs</td><td style="text-align:right">${jobCount||0}</td></tr>
            <tr><td>Manifests &amp; manifest items</td><td style="text-align:right">${mfCount||0}</td></tr>
            <tr><td>Shipments</td><td style="text-align:right">${shipCount||0}</td></tr>
            <tr><td>Finance transactions</td><td style="text-align:right">${txnCount||0}</td></tr>
            <tr><td>COD transactions</td><td style="text-align:right">${codCount||0}</td></tr>
            <tr><td>Claims</td><td style="text-align:right">${claimCount||0}</td></tr>
            <tr><td>Courier follow-ups</td><td style="text-align:right">${followupCount||0}</td></tr>
            <tr style="background:var(--ims-warning-bg)">
              <td style="color:var(--ims-warning)"><strong>Stock reserved_qty</strong></td>
              <td style="text-align:right;color:var(--ims-warning)">→ reset to 0</td>
            </tr>
          </tbody>
        </table>`;
    } else {
      const [
        {count:dsCount},{count:invCount},{count:invLineCount}
      ]=await Promise.all([
        client.from('orders').select('*',{count:'exact',head:true}).eq('fulfillment_type','dropship'),
        client.from('dropship_invoices').select('*',{count:'exact',head:true}),
        client.from('dropship_invoice_lines').select('*',{count:'exact',head:true})
      ]);
      countHtml=`
        <table class="ims__table" style="margin:12px 0">
          <thead><tr>
            <th>Table</th>
            <th style="text-align:right">Records to delete</th>
          </tr></thead>
          <tbody>
            <tr><td>Dropship orders</td><td style="text-align:right;font-weight:600;color:var(--ims-danger)">${dsCount||0}</td></tr>
            <tr><td>Dropship invoices</td><td style="text-align:right">${invCount||0}</td></tr>
            <tr><td>Dropship invoice lines</td><td style="text-align:right">${invLineCount||0}</td></tr>
          </tbody>
        </table>`;
    }

    ui().openModal(
      `⚠ Confirm reset — ${type==='orders'?'Orders & Logistics':'Dropship'}`,
      `<div class="ims__alert ims__alert--danger" style="margin-bottom:12px">
        <i class="ti ti-alert-triangle"></i>
        <span>You are about to permanently delete <strong>${labels[type]}</strong>.<br>
        This action <strong>cannot be undone</strong>.</span>
      </div>
      ${countHtml}
      <div class="ims__form-group" style="margin-top:12px">
        <label class="ims__label" style="color:var(--ims-danger)">
          Type <strong>RESET</strong> to confirm — this is your last chance to cancel
        </label>
        <input class="ims__input" type="text" id="ims-reset-confirm-input"
          placeholder="Type RESET here" autocomplete="off"
          style="font-size:16px;font-weight:700;letter-spacing:.15em;text-transform:uppercase"
          oninput="this.value=this.value.toUpperCase()">
      </div>`,
      `<button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel — keep data</button>
       <button class="ims__btn ims__btn--danger" id="ims-reset-execute-btn"
         onclick="window.IMS_COMPANY.executeReset('${type}')">
         <i class="ti ti-trash"></i> Permanently delete
       </button>`,
      'sm'
    );
  }

  async function executeReset(type){
    const input=document.getElementById('ims-reset-confirm-input')?.value?.trim();
    if(input!=='RESET'){
      ui().toast('You must type RESET exactly to confirm','error');
      document.getElementById('ims-reset-confirm-input')?.focus();
      return;
    }

    const btn=document.getElementById('ims-reset-execute-btn');
    if(btn){btn.disabled=true;btn.innerHTML='<i class="ti ti-loader-2 ims__spin"></i> Deleting...';}

    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    // Sentinel filter: Supabase requires at least one filter on .delete()
    // .gte('created_at','2000-01-01') matches all real records safely
    const ALL=q=>q.gte('created_at','2000-01-01');

    try{
      if(type==='orders'){
        // Delete in FK-safe order: children first, parents last

        // 1. Activity logs
        await ALL(client.from('order_activity_log').delete());
        // 2. Courier follow-ups
        await ALL(client.from('courier_followups').delete());
        // 3. Claims
        await ALL(client.from('claims').delete());
        // 4. Manifest items
        await ALL(client.from('manifest_items').delete());
        // 5. Manifests
        await ALL(client.from('manifests').delete());
        // 6. COD transactions
        await ALL(client.from('cod_transactions').delete());
        // 7. Zero out COD account balances (keep accounts, just clear balance)
        await client.from('driver_cod_accounts').update({balance:0,last_reconciled_at:new Date().toISOString()}).gte('created_at','2000-01-01');
        // 8. Shipments
        await ALL(client.from('shipments').delete());
        // 9. Logistics jobs
        await ALL(client.from('logistics_jobs').delete());
        // 10. Finance transactions
        await ALL(client.from('transactions').delete());
        // 11. Accounts receivable
        await ALL(client.from('accounts_receivable').delete());
        // 12. Order batches
        await ALL(client.from('order_batches').delete());
        // 13. Order postcode history
        await ALL(client.from('order_postcode_history').delete());
        // 14. Stock movements
        await ALL(client.from('stock_movements').delete());
        // 15. Order items for non-dropship orders
        const {data:nonDsOrders}=await client.from('orders').select('id').neq('fulfillment_type','dropship');
        const nonDsIds=(nonDsOrders||[]).map(o=>o.id);
        if(nonDsIds.length){
          // batch in groups of 100 to avoid URL length limits
          for(let i=0;i<nonDsIds.length;i+=100){
            await client.from('order_items').delete().in('order_id',nonDsIds.slice(i,i+100));
          }
        }
        // 16. Non-dropship orders
        await client.from('orders').delete().neq('fulfillment_type','dropship');
        // 17. Reset reserved_qty to 0 on all stock levels
        await client.from('stock_levels').update({reserved_qty:0}).gte('created_at','2000-01-01');

        ui().closeModal();
        ui().toast(
          'Reset complete — all orders, logistics, and finance records deleted. Stock reservations cleared.',
          'success', 7000
        );

      } else {
        // Dropship reset

        // 1. Get dropship order IDs
        const {data:dsOrders}=await client.from('orders').select('id').eq('fulfillment_type','dropship');
        const dsIds=(dsOrders||[]).map(o=>o.id);

        if(dsIds.length){
          // 2. Order items, activity logs, logistics jobs for dropship orders
          for(let i=0;i<dsIds.length;i+=100){
            const batch=dsIds.slice(i,i+100);
            await client.from('order_items').delete().in('order_id',batch);
            await client.from('order_activity_log').delete().in('order_id',batch);
            await client.from('logistics_jobs').delete().in('order_id',batch);
          }
        }

        // 3. Invoice lines then invoices
        await ALL(client.from('dropship_invoice_lines').delete());
        await ALL(client.from('dropship_invoices').delete());

        // 4. Dropship orders
        await client.from('orders').delete().eq('fulfillment_type','dropship');

        ui().closeModal();
        ui().toast(
          'Reset complete — all dropship orders and invoices deleted.',
          'success', 6000
        );
      }

    }catch(e){
      ui().toast('Reset failed: '+e.message,'error');
      if(btn){btn.disabled=false;btn.innerHTML='<i class="ti ti-trash"></i> Permanently delete';}
    }
  }

  window.addEventListener('ims:panel',e=>{if(e.detail.panel==='company')load();});
  window.addEventListener('ims:ready',()=>{
    document.getElementById('ims-company-save-btn')?.addEventListener('click',save);
  });

  window.IMS_COMPANY={load,save,previewLogo,removeLogo,loadDangerZone,confirmReset,executeReset};
})();
